import { InventoryAsset } from '../../../types';

export const eligibleServices = <T extends InventoryAsset>(assets: T[]): T[] =>
  assets
    .map((asset) => ({ ...asset, origin: !asset.outside_inventory_schema_id }))
    .filter((asset) => asset.origin || asset.upstack_support_managed);
